module.exports = __webpack_public_path__ + "img/main-q-issue.29c1a54e.png";